import React from "react";
import styled, {css} from "styled-components";
import { widthMixin } from "./utility";

const _MagnifyingGlass = ({ className }) => (
  <svg className={className} viewBox="0 0 136 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle className="st st0" cx="55.5" cy="55.5" r="48" />
    <path className="st st1" d="M97.73 98 127 127.27"/>
  </svg>
);

export const MagnifyingGlass = styled(_MagnifyingGlass).attrs({
  className: "magnifying-glass-icon"
})(({ themeColor }) => css`
  ${widthMixin()}
  
  .st {
    stroke: ${themeColor};
  }
  
  .st0 {
    stroke-width: 15;
  }
  
  .st1 {
    stroke-width: 18;
    stroke-linecap: round;
  }
`);